import React, { useCallback, useMemo, useState } from 'react';
import Visibility from '../../components/Visibility';
import { Title, SubTitle, Image, Description, renderLineBreak } from '../../components/layouts';
import './style.scss';
import MobileContent from './Mobile';
import DesktopContent from './Desktop';
import { getTrack, pureTrans } from '../../helpers';
import { IMAGES } from './resource';

const track = getTrack({ block: 9 });

export function CameraMotionShot() {
  const [progress, setProgress] = useState(0);
  const [mobile, setMobile] = useState(false);
  const { a1, a2, a3, b1, b2 } = useMemo(
    () => ({
      // title
      a1: pureTrans(progress, [-0.2, -0.1, 0.1], [0, 0.8, 1], 3),
      a2: pureTrans(progress, [-0.1, 0, 0.1], [0, 0.8, 1], 3),
      a3: pureTrans(progress, [-0.2, -0.1, 0.1, 0.15], [50, 10, -10, -100], 3),

      // picture
      b1: pureTrans(progress, [-0.1, 0.1, 0.15, 0.3], [1, 1, 1, 1], 3),
      b2: pureTrans(progress, [-0.1, 0.1, 0.15, 0.3], [20, -10, -20, -40], 3)
    }),
    [progress]
  );

  const handleUpdate = useCallback(
    (e, { calculations: { percentagePassed, width } }) => {
      setMobile(width <= 750);
      setProgress(percentagePassed);
    },
    [setProgress]
  );

  return (
    <Visibility fireOnMount offset={[-1000, 0]} onUpdate={handleUpdate} className="page-section section-camera-motion inverted">
      {/*<div className="section-content title center">*/}
      {/*  <Title style={{ transform: `translateY(${a3}%)` }}>*/}
      {/*    <span style={{ opacity: a1 }}>运动</span>*/}
      {/*    <span style={{ opacity: a2 }}>拍摄</span>*/}
      {/*  </Title>*/}
      {/*</div>*/}

      <div className="section-content title center">
        <Title>
          <span>运动</span>
          <span>拍摄</span>
        </Title>
      </div>

      <div className="section-6-block-1" style={{ opacity: b1, transform: `translateY(${b2}%)` }} data-track={track}>
        <div className={`section-content ${mobile ? '' : 'center'}`}>
          <SubTitle>
            多焦段运动抓拍
            <br />
            {/*跑得再快{renderLineBreak(mobile)}都抓得住*/}
            跑得再快，也抓得住
          </SubTitle>
          {/* <Description>
            <span>1倍微云台抓拍，2倍人像镜头抓拍，5倍望远抓拍，“咻”地跃起瞬间，也能轻松留住。</span>
          </Description> */}
        </div>
        {!mobile && <Image src={IMAGES[0]} className="section-6-image-1" />}
        {mobile && <Image src={IMAGES[0]} className="section-6-image-1" />}
      </div>


      <DesktopContent progress={progress} mobile={mobile} />
      {/*{mobile && <MobileContent progress={progress} />}*/}
      {/*{!mobile && <DesktopContent progress={progress} />}*/}
    </Visibility>
  );
}
